import React from "react";

import styles from "../link-app.module.css";

type EmailLinkProps = {
  subject: string
  body?: string
}

const EmailLink: React.FC<EmailLinkProps> = ({ subject, body }) => {
  let params = `subject=${encodeURIComponent(subject)}`;
  if (body) params += `&body=${encodeURIComponent(body)}`;

  const link = `mailto:support@havenconnect.com?${params}`;

  return (
    <>
      <p className={styles.emailLink}>
        If you are having trouble creating your account or linking your applications,
        please <a href={link}>follow this link</a> to send us an email, or send us an
        email to support@havenconnect.com with the subject line:
      </p>
      <p className={styles.emailLink}>
        <strong>{subject}</strong>
      </p>
      {body && (
        <>
          <p className={styles.emailLink}>and the message:</p>
          <pre>{body}</pre>
        </>
      )}
    </>
  );
};

export default EmailLink;
